import type { FindSubcategory } from '@/models/types';

/**
 * Supported options for the "Finds subcategory" field.
 *
 * The first entry, `None`, is the default applied to every product that does
 * not explicitly set a subcategory. These values mirror the database check
 * constraint (`products_find_subcategory_check`) added in migration
 * `20260918000000_add_find_subcategory_column.sql`.
 */
export const FIND_SUBCATEGORIES: FindSubcategory[] = ['None', 'Budget', 'Quality'];

/** The value applied when no subcategory is provided. */
export const DEFAULT_FIND_SUBCATEGORY: FindSubcategory = 'None';

/**
 * Type guard / normaliser: returns `true` when `value` is one of the supported
 * subcategory values.
 */
export const isFindSubcategory = (value: unknown): value is FindSubcategory =>
  typeof value === 'string' && (FIND_SUBCATEGORIES as string[]).includes(value);

/**
 * Normalises any incoming value to a valid subcategory.
 * Falls back to `None` when the value is missing, empty, or unsupported — this
 * keeps product create/update flows backward-compatible.
 */
export const normalizeFindSubcategory = (value: unknown): FindSubcategory =>
  isFindSubcategory(value) ? value : DEFAULT_FIND_SUBCATEGORY;